<template>
  <v-card outlined class="mr-2" v-if="item">
    <v-row no-gutters align="center" class="flex-nowrap">
      <v-col cols="6">
        <v-list-item class="font-weight-medium"
          ><v-list-item-icon>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-icon>
          <span v-if="item.department">{{ item.department }},&nbsp;</span>
          <span v-if="item.details.length > 0"
            >{{ item.details.length }} Personen</span
          >
          <span v-else> Personen noch unbekannt </span>
        </v-list-item>
      </v-col>
      <v-col cols="2" class="text-center">
        <v-tooltip
          top
          v-if="item.account.code == 'fieldTrip' && (lastYear || nextYear)"
        >
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">GYM1/Spesen</span>
          </template>
          <span>Spesen für LK oder Stufe GYM1 für Schüler:innen</span>
        </v-tooltip>
        <v-tooltip top v-else>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">Spesen</span>
          </template>
          <span>Spesen für LK</span>
        </v-tooltip>
      </v-col>
      <v-col cols="2" class="pa-3 text-right" v-if="!item.currency.local"
        >Fremdwährung</v-col
      >
      <v-col :cols="item.currency.local ? '4' : '2'" class="pa-3 text-right"
        >Betrag</v-col
      >
    </v-row>
    <v-divider />
    <v-row
      no-gutters
      v-for="(detail, index) in item.details"
      :key="index"
      align="center"
    >
      <v-col cols="6" class="pl-2">
        <PersonItem small :value="detail.person"> </PersonItem>
      </v-col>

      <v-col cols="2" class="d-flex justify-center">
        <template v-if="detail.person.code">
          <v-tooltip top v-if="detail.expenses">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on"
                >mdi-check</v-icon
              >
            </template>
            <span>Spesenbetrag für LK</span>
          </v-tooltip>
          <v-tooltip top v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on"
                >mdi-close</v-icon
              >
            </template>
            <span>Kein Spesenbetrag für LK</span>
          </v-tooltip>
        </template>
        <template
          v-else-if="item.account.code == 'fieldTrip' && (lastYear || nextYear)"
        >
          <v-tooltip top v-if="detail.gym1 === true">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="info" v-bind="attrs" v-on="on">mdi-check</v-icon>
            </template>
            <span>Stufe war zum Rechungszeitpunkt GYM1</span>
          </v-tooltip>
          <v-tooltip top v-else-if="detail.gym1 === false">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="info" v-bind="attrs" v-on="on">mdi-close</v-icon>
            </template>
            <span>Stufe war zum Rechungszeitpunkt > GYM1</span>
          </v-tooltip>
          <v-tooltip top v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="info" v-bind="attrs" v-on="on">mdi-minus</v-icon>
            </template>
            <span>Stufe wurde noch nicht erfasst</span>
          </v-tooltip>
        </template>
      </v-col>
      <v-col
        cols="2"
        v-if="!item.currency.local"
        align-self="center"
        class="pa-3 text-right"
      >
        <CurrencyValue
          :value="detail.amountForeign"
          :currency="item.currency.code"
        />
      </v-col>
      <v-col
        :cols="item.currency.local ? '4' : '2'"
        align-self="center"
        class="pa-3 text-right"
      >
        <CurrencyValue
          v-if="detail.amount"
          :value="detail.amount"
          currency="CHF"
        />
        <span v-else class="text--disabled">CHF ?.??</span>
      </v-col>
    </v-row>
    <v-divider />
    <v-row no-gutters align="center" class="font-weight-bold">
      <v-col cols="6" class="pl-4">Total</v-col>
      <v-col cols="2"></v-col>
      <v-col cols="2" class="pa-3 text-right" v-if="!item.currency.local">
        <CurrencyValue
          :value="item.amountForeign"
          :currency="item.currency.code"
        />
      </v-col>
      <v-col :cols="item.currency.local ? '4' : '2'" class="pa-3 text-right">
        <CurrencyValue v-if="item.amount" :value="item.amount" currency="CHF" />
        <span v-else class="text--disabled">CHF ?.??</span>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { defineComponent } from "vue";
import CurrencyValue from "common/components/CurrencyValue";
import PersonItem from "common/components/PersonItem";
import { dateDiff, formatDatespan } from "common/utils/date.js";

export default defineComponent({
  components: {
    CurrencyValue,
    PersonItem,
  },
  props: ["item"],
  data: () => ({}),

  computed: {
    foreign() {
      return this.item.currency && !this.item.currency.local;
    },
    lastYear() {
      return dateDiff(this.item.date, this.item.schoolYear.endDate) < 0;
    },
    nextYear() {
      return dateDiff(this.item.date, this.item.schoolYear.startDate) > 0;
    },
  },
  methods: {
    formatDatespan,
  },
});
</script>
